module.exports = __webpack_public_path__ + "img/sina03.190001b7.png";